export const API_DEMO_DOMAIN_ENDPOINT = '/config/api-demo-domain';
export const FALLBACK_API_DEMO_BASE_URL = 'https://playground.z.wiki';

interface ApiResponse<T> {
  success?: boolean;
  data?: T;
  message?: string;
}

interface ApiDemoDomainData {
  baseUrl: string;
}

const normalizeApiDemoBaseUrl = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || !url.host || url.pathname !== '/' || url.search || url.hash || url.username || url.password) {
      return undefined;
    }
    return url.origin;
  } catch {
    return undefined;
  }
};

export const loadApiDemoBaseUrl = async (): Promise<string> => {
  const response = await fetch(API_DEMO_DOMAIN_ENDPOINT, {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
  });
  const result = await response.json() as ApiResponse<ApiDemoDomainData>;
  const baseUrl = normalizeApiDemoBaseUrl(result.data?.baseUrl);
  if (!response.ok || result.success !== true || !baseUrl) {
    throw new Error(result.message || 'API demo domain configuration is invalid');
  }
  return baseUrl;
};
